import React from 'react';
import { FieldRichLabel } from './field-rich-label';
const RICOS_THEME = {
    customStyles: {
        p: {
            fontSize: 'var(--wix-forms-formInputValueFont-size, 16px)',
            fontFamily: 'var(--wix-forms-formInputValueFont-family)',
            fontWeight: 'var(--wix-forms-formInputValueFont-weight)',
            fontStyle: 'var(--wix-forms-formInputValueFont-style)',
            textDecoration: 'var(--wix-forms-formInputValueFont-text-decoration)',
            color: 'rgb(var(--wix-forms-formInputOptionColor, 0,0,0))'
        }
    }
};
export const FieldRichLabelWUT = (props)=>/*#__PURE__*/ React.createElement(FieldRichLabel, {
        ricosTheme: RICOS_THEME,
        ...props
    });

//# sourceMappingURL=field-rich-label-wut.js.map